import { formatDateForFilter } from "../../../features/dataFormatFunctions/dataFormatter";
import { tableEnums } from "./tableEnums";

export function prepareQueryArgsForTableFetch(lazyState: any, columns: any) {
    let sortString: any = ''
    let filterStringArray: any = []
    let page = 0
    if (lazyState) {
        page = lazyState?.page ?? 0
        let sortField = lazyState?.sortField, sortOrder = lazyState?.sortOrder;
        let filters: any = lazyState?.filters
        for (const filter in filters) {
            const col = columns.filter((col: any) => col.field === filter)[0]
            const matchMode = filters[filter].matchMode
            let filterValue = filters[filter].value
            if (filterValue != null && filterValue != '') {
                if (matchMode === 'startsWith') {
                    filterStringArray.push(`startsWith(${filter}, '${filterValue}')`)
                }
                if (matchMode === 'contains') {
                    filterStringArray.push(`position('${filterValue}', ${filter}) gt 0`)
                }
                if (matchMode === 'equals' && tableEnums[filter]) {
                    filterStringArray.push(`${filter} eq ${filterValue}`)
                }
                if (matchMode === 'equals' && !tableEnums[filter]) {
                    if (col.valueType === 'date') {
                        filterStringArray.push(`${filter} eq ${formatDateForFilter(filterValue?.replace(/\\./g, '-'))}`)
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4))
                        const lowEdge = filterValue - 0.0005
                        const highEdge = filterValue + 0.0005
                        filterStringArray.push(`${filter} ge ${lowEdge} and ${filter} le ${highEdge}`)
                    }
                }
                if (matchMode === 'gt') {
                    if (col.valueType === 'date') {
                        filterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) + 0.0005
                    }
                    filterStringArray.push(`${filter} gt ${filterValue}`)
                }
                if (matchMode === 'gte') {
                    if (col.valueType === 'date') {
                        filterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                        filterStringArray.push(`${filter} ge ${filterValue}`)
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) - 0.0005
                        filterStringArray.push(`${filter} gt ${filterValue}`)
                    }
                }
                if (matchMode === 'lt') {
                    if (col.valueType === 'date') {
                        filterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) - 0.0005
                    }
                    filterStringArray.push(`${filter} lt ${filterValue}`)
                }
                if (matchMode === 'lte') {
                    if (col.valueType === 'date') {
                        filterValue = formatDateForFilter(filterValue?.replace(/\\./g, '-'))
                        filterStringArray.push(`${filter} le ${filterValue}`)
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4)) + 0.0005
                        filterStringArray.push(`${filter} lt ${filterValue}`)
                    }
                }
                if (matchMode === 'notEquals') {
                    if (col.valueType === 'date') {
                        filterStringArray.push(`${filter} ne ${formatDateForFilter(filterValue?.replace(/\\./g, '-'))}`)
                    } else {
                        filterValue = parseFloat(parseFloat(filterValue?.replace(',', '.'))?.toFixed(4))
                        const lowEdge = filterValue - 0.0005
                        const highEdge = filterValue + 0.0005
                        filterStringArray.push(`(${filter} le ${lowEdge} or ${filter} ge ${highEdge})`)
                    }
                }
            }
        }
        sortString = `${sortField ? sortField : ''}${(sortOrder != 0 && sortOrder != null) ? `${sortOrder == 1 ? ' asc' : ' desc'}` : ''}`
        if (sortField === 'MaintenancePosition') {
            sortString = `MaintenancePositionKm${sortOrder == 1 ? ' asc' : ' desc'}` + `,` + `MaintenancePositionM${sortOrder == 1 ? ' asc' : ' desc'}`
        }
        if (sortField === 'MaintenanceEnding') {
            sortString = `MaintenanceEndingKm${sortOrder == 1 ? ' asc' : ' desc'}` + `,` + `MaintenanceEndingM${sortOrder == 1 ? ' asc' : ' desc'}`
        }
    }
    return { sortString, filterStringArray, page }
}